import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '@fragments';

// An automation's state: running, a draft, or stopped.
export default function StatusMark({ status }) {
  const { t } = useTranslation('studioAutomations');
  const Chip = { active: StatusChip.Success, paused: StatusChip.Alert, draft: StatusChip.Default }[status] || StatusChip.Default;
  return <Chip text={t(`status_${status}`)} preserveCase />;
}
